<template>
  <dialog-v2
    :show="showDialog"
    :title="dialogTitle"
    :disable-save-btn="disableSaveBtn"
    save-button-text="Iniciar"
    max-width="600px"
    @close="closeDialog"
    @save="saveDialog">
    <template slot="content">
      <v-layout mb-3>
        <v-flex md4 offset-md4 pl-1>
          <v-btn outline flat class="w-100 call-type-btn ma-0" @click="form.call_type = 'softphone'">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRujJauFiE7lLurvdinpyVBK6Sa6w2V7sLTk5RhlMdt_iWqM37GizsUB62ByrxxC2u9qA&usqp=CAU" width="160px">
            <v-icon v-if="form.call_type === 'softphone'" small icon color="green">
              fas fa-check-circle
            </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="form.call_type === 'softphone'">
        <v-flex>
          <v-text-field
            v-model="form.extension_number"
            v-validate="'required'"
            data-vv-name="extension_number"
            data-vv-scope="callCenterStart"
            data-vv-as="extension"
            color="black"
            label="Extension"
            :error-messages="errors.collect('callCenterStart.extension_number')"/>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import _ from 'lodash';
import DialogV2 from '@/components/global/DialogV2';

export default {
  inject: ['$validator'],
  props: {
    call: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
    disableSaveBtn: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    DialogV2,
  },
  data() {
    const emptyForm = {
      call_type: '',
      extension_number: '',
      new_server: false,
    };
    return {
      showDialog: false,
      emptyForm,
      form: _.cloneDeep(emptyForm),
    };
  },
  computed: {
    dialogTitle() {
      return `Escuchar llamada de ${this.call.full_name}`;
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close');
      setTimeout(() => {
        this.form = _.cloneDeep(this.emptyForm);
      }, 300);
    },
    saveDialog() {
      this.$validator.validateAll('callCenterStart')
        .then((validation) => {
          if (validation && this.form.call_type) {
            this.$emit('save', {
              ...this.form,
              colekter_extension: this.call.extension
            });
          }
        });
    },
  },
  watch: {
    show() {
      this.showDialog = this.show;
    },
    'form.call_type'() {
      if (this.form.call_type !== 'softphone') {
        this.form.new_server = false;
      }
    },
  },
};
</script>

<style scoped>
.call-type-btn {
  height: 200px !important;
  border: 1px solid #000;
  border-radius: 5px;
  color: rgba(128, 128, 128, 0.72);
  position: relative;
}
.call-type-btn i {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/CallCenter/ModalSupervisorInterception.vue